import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=d3684a58&scoped=true"
import script from "./landing.js?vue&type=script&lang=js&external"
export * from "./landing.js?vue&type=script&lang=js&external"
import style0 from "./style.scss?vue&type=style&index=0&id=d3684a58&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3684a58",
  null
  
)

export default component.exports